<script lang="ts">
  export let classes: string = "h-6 w-6";
</script>

<svg
  class={classes}
  viewBox="0 0 1000 1000"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M489.5 226.499C328 231.632 280 346.999 269 409.499C283.333 386.332 328.5 335.5 395 335.5C472.5 335.5 531.5 422 567.5 449C611.237 481.803 699.123 525.115 814.5 490C906.5 462 949.167 364.332 958.5 317.999C914 378.499 846.5 414.838 763 371.999C705.5 342.499 662.5 221 489.5 226.499Z"
    fill="#07B6D5"
  />
  <path
    d="M261 500.999C99.5 506.132 51.5 621.499 40.5 683.999C54.8333 660.832 100 610 166.5 610C244 610 303 696.5 339 723.5C382.737 756.303 470.623 799.615 586 764.5C678 736.5 720.667 638.832 730 592.499C685.5 652.999 618 689.338 534.5 646.499C477 616.999 434 495.5 261 500.999Z"
    fill="#07B6D5"
  />
</svg>
